module.exports = __webpack_public_path__ + "/assets/img/93577e3b041012eddfd6e40a8052d149.svg";